import React, { useEffect, useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { deleteMoshtari, changeCustomerSearch } from "Stores/actions";
import Translator from "Languages/Utility/Translator";
import { SAVE_ALL_MOSHTARI_DATA } from "Stores/actionTypes";
import * as Icons from 'react-bootstrap-icons';

function DeleteCustomer({ row }) {
  const {
    dataRelationMoshtari,
    customerData,
    customerDataPagination,
  } = useSelector((state) => ({
    dataRelationMoshtari: state.customer.dataRelationMoshtari,
    customerData: state.customer.customerData,
    customerDataPagination: state.customer.customerDataPagination,
  }));
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      const res = await dispatch(deleteMoshtari(data));
      if (res) {
        onShowAlert();
        dispatch({
          type: SAVE_ALL_MOSHTARI_DATA,
          customerData: customerData.filter((item) => item.Id !== row.Id),
          customerDataPagination: customerDataPagination,
        });
        dispatch(changeCustomerSearch({ Name: "" }));
      }
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  useEffect(() => {
    setDeleteRelationData(dataRelationMoshtari);
  }, [dataRelationMoshtari]);

  return (
    <>
      <ActionFormatter
        title={<Translator id="hazf" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={onShowAlert}
        disabled={row.IsG && read("StypeU") !== "1"}
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        relationText={<Translator id='relationAlert' />}
        relationData={deleteRelationData}
        loading={loading}
      />
    </>
  );
}

export default DeleteCustomer;
